if (!window.Eurus.loadedScript.has("product-recommendations.js")) {
  window.Eurus.loadedScript.add("product-recommendations.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store("xProductRecommendations", {
        loading: false,
        listOfUpsellProducts: [],
        el: "",
        listUpsellId: [],
        productCount: 0,
        async loadUpsell(el, url, listId, limit, maxItems, sectionId) {
          this.el = el;
          this.loading = true;
          this.listOfUpsellProducts = [];
          this.productCount = 0;
          this.listUpsellId = [];
          for (let i = 0; i < listId.length; i++) {
            if (this.productCount >= maxItems) {
              break;
            }
            try {
              const response = await fetch(
                `${url}&product_id=${listId[i]}&limit=${limit}&intent=related`,
              );
              const text = await response.text();
              const html = document.createElement("div");
              html.innerHTML = text;
              const des = document.querySelector(".cart-upsell-carousel");
              const src = html.querySelector(".cart-upsell-carousel");
              if (src && des) des.innerHTML = src.innerHTML;
              const recommendations = html.querySelector(
                ".product-recommendations",
              );

              if (recommendations && recommendations.innerHTML.trim().length) {
                const newUpsellProducts = recommendations.querySelectorAll(
                  'template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]',
                );
                this.listOfUpsellProducts = [
                  ...newUpsellProducts,
                  ...this.listOfUpsellProducts,
                ];

                for (
                  let index = 0;
                  index < this.listOfUpsellProducts.length;
                  index++
                ) {
                  if (this.productCount >= maxItems) {
                    break;
                  }

                  const element = this.listOfUpsellProducts[index];
                  const elementId = new DOMParser()
                    .parseFromString(element.innerHTML, "text/html")
                    .querySelector(
                      ".hover-text-link, .link-product-variant",
                    ).id;

                  if (!this.listUpsellId.includes(elementId)) {
                    this.listUpsellId.push(elementId);
                    el.appendChild(element);
                    this.productCount++;
                  }
                }

                if (recommendations.classList.contains("main-product")) {
                  el.className +=
                    " mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0";
                }
              } else if (
                recommendations &&
                recommendations.classList.contains("main-product")
              ) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            } catch (e) {
              console.error(e);
            } finally {
              requestAnimationFrame(() => {
                document
                  .getElementById(`x-upsell-${sectionId}`)
                  ?.splide?.refresh();
                this.loading = false;
              });
            }
          }
        },
        load(el, url) {
          this.loading = true;
          // Patch: clear the display:none set by a previous empty refetch, so the block
          // can reappear when the cart changes again (e.g. the recommended product is
          // removed). Vendor only ever set this inline style, never reset it.
          el.style.removeProperty("display");
          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                ".product-recommendations",
              );
              const hasProductCard =
                recommendations &&
                recommendations.getElementsByClassName("x-splide-slide")
                  .length > 0;
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                });
                if (recommendations.classList.contains("main-product")) {
                  // Patch: classList.add instead of `className +=`, which re-appended the
                  // same classes on every refetch (visible as a duplicated `accordion`).
                  el.classList.add(
                    "mb-4",
                    "md:mb-6",
                    "border-y",
                    "border-solid",
                    "accordion",
                    "empty:border-b-0",
                  );
                }
                this.loading = false;
              } else if (recommendations.classList.contains("main-product")) {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    recommendations.classList.add("hidden");
                    el.innerHTML = recommendations.innerHTML;
                  }, 0);
                });
              }

              if (!hasProductCard) {
                this.loading = false;
                el.style.display = "none";
              }
            })
            .catch((e) => {
              console.error(e);
              this.loading = false;
            });
        },
      });
    });
  });
}
